<!--Header-->
<app-navbar>
    <h2>{{"JOBS.TITLE" | translate}}</h2>
    <p>agri – zoo – vet – food</p>
</app-navbar>

<div class="container">
    <div class="search-area mt-20">
            <div class="col-12 bg-white px-5 pb-10 pt-10">
                <form #searchForm="ngForm" class="filterForm">
        <div class="row justify-content-start align-items-center">
            <!--Nume Job -->
            <div class="col-12 col-md-4">
                <div class="form-group">
                    <label>{{"JOBS.NAME" | translate}}</label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="jobTitle"
                    >
                </div>
            </div>
            <!--Tara -->
            <div class="col-12 col-md-3">
                <div class="form-group">
                    <label>{{"LOGIN.COUNTRY" | translate}}</label>
                    <ng-select2 [data]="locationsArrayValues"
                                [options]="singleOption"
                                id="country"
                                [(ngModel)]="selectedCountry"
                                name="country"
                                (valueChanged)="changeCountry($event)">
                    </ng-select2>
                </div>
            </div>
            <!--Oras -->
            <div class="col-12 col-md-3">
                <div class="form-group">
                    <label>Oraș</label>
                    <ng-select2 [data]="city"
                                [options]="multiOptions"
                                id="city"
                                [(ngModel)]="selectedCity"
                                name="city">
                    </ng-select2>
                </div>
            </div>
            <!--Cauta Job button-->
            <div class="col-12 col-md-2 form-group text-right">
                <button type="button" class="btn btn-light-primary px-3 font-weight-bold col-lg-12"
                        (click)="jobCall()">
                        {{"JOBS.SEARCH" | translate}} <span class="fa fa-search"></span>
                </button>
            </div>
            <!-- <div class="col-12 col-md-1 text-right form-group">
                <button class="btn btn-light-danger font-weight-bold btn-block"
                        type="button"
                        (click)="resetSearch();">
                        Reset <span class="fa fa-search"></span>
                </button>
            </div> -->
        </div>

        <div class="row" *ngIf="filterActive">
            <div class="col-12">
                <span class="mr-2 filter-title">Filtre active:</span>
                <span *ngIf="jobCriteriaData.jobTitle !== undefined" class="mr-3"><b>Denumire job: </b>{{jobCriteriaData.jobTitle}}</span>
                <span *ngIf="jobCriteriaData.country !== undefined" class="mr-3"><b>Țară: </b>{{jobCriteriaData.country}}</span>
                <span *ngIf="jobCriteriaData.city !== undefined" class="mr-3"><b>Oraș: </b>{{jobCriteriaData.city}}</span>
                <span *ngIf="jobCriteriaData.workType !== undefined" class="mr-3"><b>Tip job: </b>{{jobCriteriaData.workType}}</span>
                <span *ngIf="jobCriteriaData.contractType !== undefined" class="mr-3"><b>Tip Contract: </b>{{jobCriteriaData.contractType}}</span>
                <span *ngIf="jobCriteriaData.experienceLevel !== undefined" class="mr-3"><b>Nivel Experienta: </b>{{jobCriteriaData.experienceLevel}}</span>
                <span *ngIf="jobCriteriaData.jobDisponibility !== undefined" class="mr-3"><b>Disponibilitate Începere Job: </b>{{jobCriteriaData.jobDisponibility}}</span>
                <span *ngIf="jobCriteriaData.activitySector !== undefined" class="mr-3"><b>Domeniu: </b>{{jobCriteriaData.activitySector}}</span>
                <span *ngIf="jobCriteriaData.activitySubSector !== undefined" class="mr-3"><b>Subdomeniu: </b>{{jobCriteriaData.activitySubSector}}</span>
                <span *ngIf="jobCriteriaData.category !== undefined" class="mr-3"><b>Categorii: </b>{{jobCriteriaData.category}}</span>
                <span *ngIf="jobCriteriaData.department !== undefined" class="mr-3"><b>Departamente: </b>{{jobCriteriaData.department}}</span>
                <span *ngIf="jobCriteriaData.language !== undefined" class="mr-3"><b>Limbi straine: </b>{{jobCriteriaData.language}}</span>
                <span *ngIf="jobCriteriaData.physicalEffortType !== undefined" class="mr-3"><b>Efort fizic: </b>{{jobCriteriaData.physicalEffortType}}</span>
                <span *ngIf="jobCriteriaData.physicalEffortType !== undefined" class="mr-3"><b>Experienta domeniu similar: </b>{{jobCriteriaData.physicalEffortType}}</span>
                <span *ngIf="jobCriteriaData.studies !== undefined" class="mr-3"><b>Studii: </b>{{jobCriteriaData.studies}}</span>
                <span *ngIf="jobCriteriaData.totalExperience !== undefined" class="mr-3"><b>Experiență Totală de Muncă(ani): </b>{{jobCriteriaData.totalExperience}}</span>
                <span *ngIf="jobCriteriaData.bonus !== undefined" class="mr-3"><b>Bonus: </b>{{jobCriteriaData.bonus}}</span>
                <span *ngIf="jobCriteriaData.otherBenefits !== undefined" class="mr-3"><b>Alte Beneficii: </b>{{jobCriteriaData.otherBenefits}}</span>
                <span *ngIf="jobCriteriaData.careerPossibility !== undefined" class="mr-3"><b>Posibilitati de Cariera: </b>{{jobCriteriaData.careerPossibility}}</span>
                <span *ngIf="jobCriteriaData.workProgram !== undefined" class="mr-3"><b>Program de Lucru: </b>{{jobCriteriaData.workProgram}}</span>
                <span *ngIf="jobCriteriaData.workSpace !== undefined" class="mr-3"><b>Spatiu de Lucru: </b>{{jobCriteriaData.workSpace}}</span>
                <span *ngIf="jobCriteriaData.driverLicense !== undefined" class="mr-3"><b>Permis de Conducere: </b>{{jobCriteriaData.driverLicense}}</span>
                <span *ngIf="jobCriteriaData.availableForTraveling !== undefined" class="mr-3"><b>Disponibilitate la Deplasare: </b>{{jobCriteriaData.availableForTraveling}}</span>
                <span *ngIf="jobCriteriaData.relocationPossibility !== undefined" class="mr-3"><b>Posibilitate Relocare: </b>Da</span>
                <span *ngIf="jobCriteriaData.relocationPackageIncluded !== undefined" class="mr-3"><b>Facilitati Relocare: </b>Da</span>
                <span *ngIf="jobCriteriaData.legalWorkPermitMandatory !== undefined" class="mr-3"><b>Permis de Munca Obligatoriu: </b>Da</span>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <button class="btn btn-light-primary col-lg-12" type="button" data-toggle="collapse"
                        data-target="#filterJobs"
                        aria-expanded="false" aria-controls="filterJobs">
                        {{"JOBS.ADV_SEARCH" | translate}}
                    <span class="fa fa-sliders-h"></span>
                </button>
            </div>
        </div>


        <div class="col-12 bg-white">
            <div class="collapse" id="filterJobs">
                <div class="row pt-10">
                    <!--Work Type -->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.TIPE" | translate}}</label>
                            <select
                                    id="workType"
                                    class="form-control"
                                    [(ngModel)]="workType"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="volunteer">Voluntariat</option>
                                <option value="practice">Practica</option>
                                <option value="project">Proiect</option>
                                <option value="temporary">Temporar</option>
                                <option value="part_time">Part-Time</option>
                                <option value="full_time">Full-Time</option>
                                <option value="remote">La Distanta(Remote)</option>
                                <option value="internship">Internship</option>
                            </select>
                        </div>
                    </div>
                    <!--Contract Type-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.CONTRACT_TIPE" | translate}}</label>
                            <select
                                    id="contractType"
                                    class="form-control"
                                    [(ngModel)]="contractType"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="employment" selected>Angajare</option>
                                <option value="contractor">Contractor (Pers. Juridica)</option>

                            </select>
                        </div>
                    </div>
                    <!--Experience Level-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.EXPERIANCE" | translate}}</label>
                            <select id="experienceLevel"
                                    class="form-control"
                                    [(ngModel)]="experienceLevel"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="student" selected>Student</option>
                                <option value="entry_level">Proaspat Absolvent</option>
                                <option value="junior">Junior</option>
                                <option value="specialist">Specialist</option>
                                <option value="senior">Senior</option>
                                <option value="executive">Top Manager/Executiv</option>
                            </select>
                        </div>
                    </div>
                    <!--Job Disponibility-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.AVAILABLITY" | translate}}</label>
                            <select id="jobDisponibility"
                                    class="form-control"
                                    [(ngModel)]="jobDisponibility"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="immediate" selected>Imediat</option>
                                <option value="in_15_days">15 Zile</option>
                                <option value="in_30_days">30 Zile</option>
                                <option value="in_6_months">6 Luni</option>
                                <option value="in_9_months">9 Luni</option>
                                <option value="in_12_months">12 Luni</option>
                            </select></div>
                    </div>
                    <!--Activity Sector -->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"HOMEPAGE.CARREAR_IMPROVMENT.DOMAIN" | translate}}</label>
                            <select [(ngModel)]="selectedDomain"
                                    (change)="changeDomain($event)"
                                    class="form-control"
                                    name="activitySector"
                                    required
                                    #domainController="ngModel">
                                <option *ngFor="let country of Domains">{{country.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Activity Sub Sector -->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"HOMEPAGE.CARREAR_IMPROVMENT.SUBDOMAIN" | translate}}</label>
                            <ng-select2
                                    [(ngModel)]="selectSubdomains"
                                    [data]="subDomainsArray"
                                    [options]="singleOption"
                                    (valueChanged)="changeSubDomain($event)"
                            >
                            </ng-select2>
                        </div>
                    </div>

                    <!--Activity Micro Sector -->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.CATEGORIES" | translate}}</label>
                            <ng-select2
                                    [(ngModel)]="selectedCategories"
                                    [data]="categoriesArray"
                                    [options]="singleOption"
                            >
                            </ng-select2>
                        </div>
                    </div>
                    <!--Department-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.DEPARTMENT" | translate}}</label>
                            <ng-select2 [data]="departments"
                                        [options]="multiOptions"
                                        [(ngModel)]="selectedDepartments"
                            >
                            </ng-select2>
                        </div>
                    </div>
                    <!--Foreign Languages-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.LANGUAGES" | translate}}</label>
                            <select class="form-control"
                                    [(ngModel)]="foreignLanguages"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let lang of languages">{{lang}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <!--Psyhical Effort-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.EFFORT" | translate}}</label>
                            <select class="form-control"
                                    [(ngModel)]="physicalEffort"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="Normal">Normal</option>
                                <option value="Suplimentar">Suplimentar</option>
                                <option value="Specifice">Specifice</option>
                            </select>
                        </div>
                    </div>
                    <!--Similar Experience-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.OTHER_EXPERIANCE" | translate}}</label>
                            <select class="form-control"
                                    [(ngModel)]="similarExperience"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let department of departments">{{department}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Studies-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.STUDYES" | translate}}</label>
                            <select id="studies"
                                    class="form-control"
                                    [(ngModel)]="selectedStudies"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let studies of selectStudies"
                                        value="{{studies.valueName}}">{{studies.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Total Experience-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.WORK_EXPERIANCE" | translate}}</label>
                            <div class="input-group">
                                <input class="form-control"
                                       type="number"
                                       [(ngModel)]="totalExperience">
                                <div class="input-group-prepend">
                                    <div class="input-group-text currency-box">Ani</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Bonus-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>Bonus</label>
                            <select id="bonus" class="form-control" [(ngModel)]="selectedBonus">
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let bonus of selectBonus"
                                        value="{{bonus.valueName}}">{{bonus.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Other Benefits-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.OTHER_BENEFITS" | translate}}</label>
                            <ng-select2 [data]="selectOtherBenefits"
                                        [options]="multiOptions"
                                        [(ngModel)]="selectedOtherBenefits"
                            ></ng-select2>
                        </div>
                    </div>
                    <!--Career Possibility-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.CARRERA_POS" | translate}}</label>
                            <ng-select2 [data]="selectCareerPossibility"
                                        [options]="multiOptions"
                                        [(ngModel)]="selectedCRP"
                            ></ng-select2>
                        </div>
                    </div>
                    <!--Work Program-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.WORK_SCHED" | translate}}</label>
                            <select class="form-control" [(ngModel)]="selectedWP">
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let workProg of selectWorkProgram"
                                        value="{{workProg.valueName}}">{{workProg.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Work Space-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.WORK_PLACE" | translate}}</label>
                            <select class="form-control" [(ngModel)]="selectedWS">
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option *ngFor="let workSpace of selectWorkSpace"
                                        value="{{workSpace.valueName}}">{{workSpace.name}}</option>
                            </select>
                        </div>
                    </div>
                    <!--Drive License-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.LICENSE" | translate}}</label>
                            <ng-select2 [data]="driveLicense"
                                        [options]="multiOptions"
                                        [(ngModel)]="selectedDriveLicense"
                            >
                            </ng-select2>
                        </div>
                    </div>
                    <!--Available For Traveling-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label>{{"JOBS.MOVMENT" | translate}}</label>
                            <select class="form-control"
                                    [(ngModel)]="availableForTraveling"
                            >
                                <option value="">{{"JOBS.OPPTION" | translate}}</option>
                                <option value="10%">10%</option>
                                <option value="25%">25%</option>
                                <option value="50%">50%</option>
                                <option value="75%">75%</option>
                                <option value="100%">100%</option>
                                <option value="Altele">Altele</option>
                            </select>
                        </div>
                    </div>
                    <!--Relocation Possibility-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <div class="job-type-area">
                                <label for="relocationPossibility"
                                       class="checkbox-container">
                                       {{"JOBS.RELOCATE" | translate}}
                                    <input class="form-check-input"
                                           type="checkbox"
                                           id="relocationPossibility"
                                           [(ngModel)]="relocationPossibility">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!--Relocation Package Included-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <div class="job-type-area">
                                <label for="relocationPackageIncluded"
                                       class="checkbox-container">
                                       {{"JOBS.RELOACATE_BENEFITS" | translate}}
                                    <input class="form-check-input"
                                           type="checkbox"
                                           id="relocationPackageIncluded"
                                           name="relocationPackageIncluded"
                                           [(ngModel)]="relocationPackageIncluded">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!--Legal Work Permit Mandatory-->
                    <div class="col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <div class="job-type-area">
                                <label for="legalWorkPermitMandatory"
                                       class="checkbox-container">
                                       {{"JOBS.WORK_PERMIT" | translate}}
                                    <input class="form-check-input"
                                           type="checkbox"
                                           id="legalWorkPermitMandatory"
                                           [(ngModel)]="legalWorkPermitMandatory">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-6 text-right form-group">
                        <button class="btn btn-light-danger font-weight-bold btn-block"
                                type="button"
                                (click)="resetSearch();">
                            <span class="fa fa-search"></span> {{"JOBS.RESET_SERCH" | translate}}
                        </button>
                    </div>
                    <div class="col-md-6 text-right form-group">
                        <button class="btn btn-light-primary font-weight-bold btn-block"
                                type="button"
                                (click)="jobCall();">
                            <span class="fa fa-search"></span> {{"JOBS.SERCH" | translate}}
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </form>
        </div>
</div>

    <div class="mb-5">
        <div class="row mt-5">
            <div class="col-md-3">
                <div class="d-flex align-items-center">
                    <label class="mr-3 mb-0">{{"JOBS.RESULTS" | translate}}: </label>
                    <select (change)="onSizeChange($event)" class="form-control">
                        <option *ngFor="let size of selectPageSize" [ngValue]="size">
                            {{ size }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-6 offset-3">
                <div class=" row d-flex align-items-center justify-content-end">
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="mr-3 mb-0">{{"JOBS.SORT" | translate}}: </label>
                        <select (change)="onSortChange($event)" class="form-control" [ngModel]="'jobPostingDate'">
                            <option [ngValue]="undefined">{{"JOBS.OPPTION" | translate}}</option>
                            <option *ngFor="let item of sortingValues" value="{{item.value}}">{{item.name}}</option>

                        </select>
                    </div>
                    <div class="col-md-6 d-flex align-items-center">
                        <label class="mr-3 mb-0">{{"JOBS.ORDER" | translate}}: </label>
                        <select (change)="onOrderChange($event)" class="form-control" [ngModel]="'desc'">
                            <option value="asc">{{"JOBS.ASC" | translate}}</option>
                            <option value="desc">{{"JOBS.DEC" | translate}}</option>
                        </select>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>

<!--Job area top-->
<div class="job-area-top mt-10">
    <div class="container">
        <div class="row ">
            <div class="col-12 pb-10">
                <div class="row align-items-center">
                    <div class="col">
                        <!--Display a specific number of jobs from all-->
                        <div class="display-job-number">
                            <h1>{{"JOBS.JOB_NUMBER" | translate}}: {{filteredJobs.totalElements}}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Jobs List-->
<div id="jobs-list" *ngIf="!filterRecentJobs">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-12"
                 *ngFor="let job of filteredJobs.content">
                <div class="row">
                    <div class="col-12 mb-5">
                        <!--Job-->
                            <div class="card mb-10 company-info">
                                  <!-- Right Corner Content -->
                                <div class="card-header">
                                    <span
                                        [ngClass]="{
                                        'green-background': job.workType === 'volunteer',
                                        'blue-background': job.workType === 'practice',
                                        'yellow-background': job.workType === 'internship',
                                        'tryan-purple': job.workType === 'project',
                                        'orange-background': job.workType === 'temporary',
                                        'verdigris': job.workType === 'part_time',
                                        'purple-heart ': job.workType === 'full_time',
                                        'darkgreen-background': job.workType === 'remote'}"
                                    >{{job.workType[0] | enumTransform}}</span>
                                    <span class="ml-2">{{job.jobPostingDate | date:"dd-MM-yyyy"}}</span>
                                </div>
                                <div class="card-img-top">
                                        <a routerLink="/job/{{job.id}}">
                                            <img src="{{job.photoPath}}" alt="Job Logo">
                                        </a>
                                </div>
                                <div class="card-title">
                                    <a routerLink="/job/{{job.id}}">
                                        <h5>{{job.jobTitle}}</h5>
                                    </a>
                                </div>
                                <div class="card-footer ">
                                    <i class="icofont-location-pin"><span class="ml-2 multiple-lines">{{job.country}} - <span *ngFor="let county of job.city | slice:0:3; index as i">{{i === job.city?.length-1 ? county : county+", "}}</span>...</span></i>
                                    <!-- <i class="icofont-location-pin"><span class="ml-2 multiple-lines">{{job.country}} - {{job.city | slice:0:3}} ...</span></i> -->
                                </div>
                            </div>
                        </div>

                            <!-- Right Corner Content
                            <div class="row job-type-and-date">
                                <span class="type-job-badge px-3 py-2"
                                      [ngClass]="{
                                       'green-background': job.workType === 'volunteer',
                                       'blue-background': job.workType === 'practice',
                                       'yellow-background': job.workType === 'internship',
                                       'tryan-purple': job.workType === 'project',
                                       'orange-background': job.workType === 'temporary',
                                       'verdigris': job.workType === 'part_time',
                                       'purple-heart ': job.workType === 'full_time',
                                       'darkgreen-background': job.workType === 'remote'}"
                                >{{job.workType | enumTransform}}</span>
                                <span class="post-date">{{job.jobPostingDate | date:"dd-MM-yyyy"}}</span>
                            </div>

                            Details
                            <div class="row ml-3">
                                Logo
                                <div class="col-md-8 col-12 my-5">
                                    <div class="photo-box">
                                        <a routerLink="/job/{{job.id}}">
                                            <img class="job-logo img-fluid" src="{{job.photoPath}}" alt="Job Logo">
                                        </a>
                                    </div>
                                </div>
                                Job Title
                                <div class="row job-title">
                                    <div class="mb-3">
                                        <a routerLink="/job/{{job.id}}">
                                            <h5 class="custom-section-title">{{job.jobTitle}}</h5>
                                        </a>
                                `   </div>
                                </div>
                                
                            </div>
                            Location
                            <div class="job-location">
                                <i class="icofont-location-pin"><span class="ml-2">{{job.country}} - {{job.city}}</span></i>
                            </div>  -->
                        
                        </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <ngb-pagination class="custom-pagination d-flex justify-content-center"
                                [collectionSize]="totalElements"
                                [(page)]="page"
                                [pageSize]="pageSize"
                                [rotate]="true"
                                [maxSize]="5"
                                [boundaryLinks]="true"
                                (pageChange)="onPageChange(page)"
                                aria-label="Custom pagination">
                    <ng-template ngbPaginationFirst>{{"JOBS.FIRST" | translate}}</ng-template>
                    <ng-template ngbPaginationLast>{{"JOBS.LAST" | translate}}</ng-template>
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
